<template>
    <ul id="list-tasks">
      <li>
        <div id='oblea' v-show="item.tipoOblea == 1">
          <div id='s1'>
            <img :src="imagenProducto" style="height: 52px" /> 
          </div> 
          <div id='s2'>
            <span id='titulo'>{{nombre}}</span>
          </div> 
          <div id='s22'>
            <div>
              <span class='label'>Precio:</span> 
              <span class='value'> {{moneyLabel}} {{precioComp | formatMoney}}</span>
            </div>
            <div>
              <span class='label'>Subtotal:</span>
              <span class='value'> {{moneyLabel}} {{subtotalComp | formatMoney}}</span>
            </div>
          </div> 
          <div id='s3'>
            <div id='cc'>
              <span id='cantidad'>Cantidad: {{item.Cantidad}}</span> 
            </div> 
          </div> 
          <div id='s4'>
          </div> 
        </div>
        <div id='oblea-desc' v-show="item.tipoOblea == 2" >
          <div id='s1'>  </div> 
          <div id='s2'>
            <span id='titulo'>{{item.ProductoNombre}}</span>
          </div> 
          <div id='s222'>
            <span class='value' style="margin-left: 60px">{{moneyLabel}} {{item.Precio | formatMoney}}</span>
          </div> 
          <div id='s3'>   </div> 
          <div id='s4'>   </div> 
        </div>
      </li>
    </ul>
</template>
  

   
  <script>
  import axios from 'axios'


    export default {
      name: 'item-pedidoCms',
      props: ['item'],

      computed: {
          
        moneyLabel() {
          if (this.$store.state.pedido.idMoneda == 2) {
           return 'U$S' 
          }
          else {
           return '$' 
          }
        },

        precioComp() {
          if (this.$store.state.pedido.idMoneda == 2) {
            return this.item.PrecioDolar
          }
          else {
            return this.item.Precio 
          }
        }, 

        // subtotalComp() {
        //   var sub = this.item.Precio * this.item.Cantidad
        //   if (this.$store.state.pedido.idMoneda == 2) {
        //     return sub / this.$store.state.user.usuario.CotizacionDolar
        //   }
        //   else {
        //     return sub
        //   }
        // }, 

        subtotalComp() {
          if (this.$store.state.pedido.idMoneda == 2) {
            return this.item.ImporteDolar
          }
          else {
            return this.item.Importe 
          }
        }, 


        nombre () {
          if (this.item.ProductoNombre.length > 1) {
            return this.item.ProductoNombre
          }
          else {
            return this.item.PromocionNombre
          }
        },

        imagenProducto() {
          if ((this.item.ProductoImagenUrl != null) && (this.item.ProductoImagenUrl.length > 1)) {
            return this.item.ProductoImagenUrl
          }
          else if ((this.item.PromocionImagenUrl != null) && (this.item.PromocionImagenUrl.length > 1)) {
            return this.item.PromocionImagenUrl
          }
          else {
            return '/dist/placeholder-producto.png'
          }
        } 
        
      }
    }
  </script>
  
  
  <style scoped>
  
  * {
    margin:  0;
    padding: 0;
  }
  
  
  #oblea {
    width: 630px;
    height:70px;
    margin-bottom: 5px;
    background: #ffffff;  
    border-style: solid;
    border-width: 1px;
    border: 1px solid #dddddd;
    box-shadow: 1px 1px 2px #dddddd;
    display: flex;
    align-items: flex-start; 
  }
  

  #oblea-desc {
  width: 630px;
  height:30px;
  margin-bottom: 5px;
  background-color: #ffffaa;  
  border-style: solid;
  border-width: 1px;
  border: 1px solid #dddddd;
  box-shadow: 1px 1px 3px #dddddd;
  display: flex;
  align-items: flex-start; 
}


  
#s1{
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}

#s2{
  width: 40%;
  height: 100%;
  display: flex;
  align-items: center; 
}

#s22{
  width: 24%;
  height: 100%;
  padding-left: 10px; 
  display: flex;
  flex-direction: column;
  justify-content: center;  
  align-items: flex-start; 
}

#s222{
  width: 24%;
  height: 100%;
  padding-left: 10px; 
  display: flex;
  flex-direction: row;
  justify-content: flex-start;  
  align-items: center; 
}

#s3{
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}

#s4{
  width: 6%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}
 

#titulo{
  font-size: 13px;
  color: #656E76;
  font-weight: 500;
}


.label{
  font-size: 12px;
  color: #656E76;
  font-weight: 500;
  float: left;
  width: 60px;
  margin-top: 3px;
  margin-bottom: 3px;
}


.value{
  font-size: 12px;
  color: #656E76;
  float: left;
  margin-top: 3px;
  margin-bottom: 3px;
}

#cantidad{
  font-size: 12px;
  color: #656E76;
  margin-top: 3px;
  margin-bottom: 3px;
}

 
  
</style>


// WEBPACK FOOTER //
// src/components/views/estadoPedido/itemPedidoCms.vue